interface QuizSectionCardHeaderProps {
  name?: string;
}

export default function QuizSectionCardHeader(quizSectionCardHeaderProps: QuizSectionCardHeaderProps) {
  const { name } = quizSectionCardHeaderProps;

  return (
    <div className="flex h-8 items-center gap-1">
      <span className={'text-text-secondary ml-2 truncate text-xs font-medium'}>{name}</span>
    </div>
  );
}
